import { useMemo, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { CobuText, CobuView } from '@cobu/ui'
import { type Group } from '@cobu/api-client'
import { useGroups } from '../hooks/groups/useGroups'
import GroupsGrid from '../components/groups/GroupsGrid'
import { PullToRefreshWrapper } from '../components/ui/PullToRefreshWrapper'
import { Strings } from '../constants'
import { useResidentRestrictions } from '../hooks/useResidentRestrictions'

const SPACING = 17

export default function Groups() {

  const { allGroups, myGroups, otherGroups, isLoading, handleGroupsRefresh, isRefreshing } = useGroups()
  const { canCreateGroup } = useResidentRestrictions()

  const navigate = useNavigate()
  const handleGroupPress = useCallback((id: string) => {
    navigate(`/groups/${id}`)
  }, [navigate])
  const handleSuggest = useCallback(() => {
    navigate('/groups/suggest-group')
  }, [navigate])

  // layout handled by GroupsGrid

  if (isLoading && allGroups.length === 0) return null

  const strings = Strings.get()
  const hasMy = myGroups.length > 0
  const hasOther = otherGroups.length > 0
  const otherTitle = hasMy ? strings.groups.otherGroups : strings.groups.allGroups

  return (
    <PullToRefreshWrapper
      onRefresh={handleGroupsRefresh}
      isRefreshing={isRefreshing}
      useWindowScroll={true}
    >
      <CobuView padding="$2" paddingBottom="$10" gap="$3">
        {hasMy ? (
          <GroupsGrid
            groups={myGroups}
            title={strings.groups.myGroups}
            subtitle={strings.groups.allGroupsOpenToResidents}
            onGroupPress={handleGroupPress}
            onSuggestPress={handleSuggest}
            showSuggestCard={canCreateGroup}
            suggestCardPosition={2}
          />
        ) : null}

        {hasOther || !hasMy ? (
          <GroupsGrid
            groups={hasMy ? otherGroups : allGroups}
            title={otherTitle}
            onGroupPress={handleGroupPress}
            onSuggestPress={handleSuggest}
            showSuggestCard={!hasMy && canCreateGroup}
            suggestCardPosition={0}
          />
        ) : null}
      </CobuView>
    </PullToRefreshWrapper>
  )
}
